/* @flow */

import React from 'react';
import {withRouter} from "react-router";

import LoadingComponent from 'components/loading';

import ResetPasswordViewComponent from './view';

import ResetPasswordForm from './model';

import UserService from 'services/UserService';
import {handleApiFormResponse, handleFormValidation} from 'lib/forms';
import loadConstraints from 'lib/validation/loadConstraints';
import {validateField, validateForm} from 'lib/validation/validator';
import NotificationHelper from 'lib/notifications';

import {SIGN_IN} from 'constants/pageRoutes';


type ResetPasswordComponentProps = {
  email: string;
  token: string;
}

type ResetPasswordComponentState = {
  constraints: any;
  errors: Map<string, ?string>;
  form: ResetPasswordForm;
  formErrors: string[];
  isLoading: boolean;
  isProcessing: boolean;
}

class ResetPasswordComponent extends React.Component<ResetPasswordComponentProps, ResetPasswordComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      constraints: null,
      errors: null,
      form: new ResetPasswordForm(),
      formErrors: [],
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    try {
      const constraints = await loadConstraints('Password', ['password', 'confirmPassword']);
      this.setState({
        constraints,
        errors: new Map(Object.keys(constraints).map(e => [e, undefined])),
        isLoading: false
      });
    } catch (e) {
      console.error(e);
    }
  };
  
  handlePasswordChange = (value: string) => {
    const validationResult = validateField(value, this.state.constraints.password);
    const errors = this.state.errors;
    errors.set('password', validationResult ? validationResult[0] : null);

    if (this.state.form.confirmPassword.length > 2) {
      const validationResults = validateForm({ password: value, confirmPassword: this.state.form.confirmPassword }, this.state.constraints);
      let validationResult2 = validationResults && validationResults.confirmPassword ? validationResults.confirmPassword[0] : null;
      if (validationResult2 !== null && validationResult2.includes(' ')) {
        const split = validationResult2.split(' ');
        validationResult2 = split.pop();
      }
      errors.set('confirmPassword', validationResult2);
    }

    const form = this.state.form;
    form.password = value;
    this.setState({errors, form});
  };

  handleConfirmPasswordChange = (value: string) => {
    const validationResults = validateForm({ password: this.state.form.password, confirmPassword: value }, this.state.constraints);
    let validationResult = validationResults && validationResults.confirmPassword ? validationResults.confirmPassword[0] : null;
    if (validationResult !== null && validationResult.includes(' ')) {
      const split = validationResult.split(' ');
      validationResult = split.pop();
    }

    const errors = this.state.errors;
    errors.set('confirmPassword', validationResult);

    const form = this.state.form;
    form.confirmPassword = value;
    this.setState({errors, form});
  };

  validateForm = () => handleFormValidation.call(this);

  submitForm = async () => {
    if (!this.validateForm()) return;

    this.setState({formErrors: [], isProcessing: true});

    try {
      const request = this.state.form.toRequest(this.props.email, this.props.token);
      await UserService.resetPassword(request);
      NotificationHelper.createNotification(NotificationHelper.TYPE_SUCCESS, 'notifications.password.succes');
      this.props.history.push(SIGN_IN);
    } catch (e) {
      handleApiFormResponse.call(this, e);
    }
  };

  render() {
    if (this.state.isLoading) {
      return (<LoadingComponent />);
    }

    return (
      <ResetPasswordViewComponent
        errors={this.state.errors}
        form={this.state.form}
        formErrors={this.state.formErrors}
        isProcessing={this.state.isProcessing}
        handlePasswordChange={this.handlePasswordChange}
        handleConfirmPasswordChange={this.handleConfirmPasswordChange}
        submitForm={this.submitForm}
      />
    );
  }
}

export default withRouter(ResetPasswordComponent);
